import React, { useEffect, useState } from 'react'
import PostAnimation from './PostAnimation'
import ProfileAnimation from './ProfileAnimation'
import CompanyAnimation from './CompanyAnimation'

// Adjust these if you want longer/shorter display or gap
const DISPLAY_DURATION = 10000 // how long each animated component runs (ms)
const GAP_AFTER_END = 0 // wait 1s after a component ends before starting next (ms)

const tabs = [
  { id: 'posts', label: 'Posts' },
  { id: 'people', label: 'People' },
  { id: 'companies', label: 'Companies' }
]

export default function AnimatedDiscoverSection() {
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)
  // mountKey forces a remount of the child component so its internal animation
  // starts from the beginning each time it becomes active.
  const [mountKey, setMountKey] = useState(Date.now())

  useEffect(() => {
    let hideTimer = null
    let switchTimer = null

    // schedule hide after DISPLAY_DURATION
    hideTimer = setTimeout(() => {
      setVisible(false)

      // after a short gap, switch index and remount next component
      switchTimer = setTimeout(() => {
        setIndex(prev => (prev + 1) % tabs.length)
        setMountKey(Date.now())
        setVisible(true)
      }, GAP_AFTER_END)
    }, DISPLAY_DURATION)

    return () => {
      clearTimeout(hideTimer)
      clearTimeout(switchTimer)
    }
  }, [index])

  // choose which component to render
  const renderActive = () => {
    if (!visible) return null

    if (index === 0) return <PostAnimation key={mountKey} />
    if (index === 1) return <ProfileAnimation key={mountKey} />
    return <CompanyAnimation key={mountKey} />
  }

  return (
    <section id="product" className="py-12 md:py-16 w-full overflow-hidden">
      <div className="w-11/12 md:w-4/5 max-w-7xl mx-auto px-2 md:px-0">
        <h2 className="text-center text-3xl md:text-5xl font-bold mb-8 md:mb-12">Discover What You Need:</h2>

        <div className="flex items-center justify-center gap-4 md:gap-8 text-base md:text-2xl mb-6 md:mb-8 select-none">
          {tabs.map((t, i) => (
            <div
              key={t.id}
              className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full transition-colors duration-300 ${
                i === index ? 'text-[#141e39] font-semibold' : 'text-gray-500'
              }`}
              aria-hidden
            >
              {t.label}
            </div>
          ))}
        </div>

        {/* animated area */}
        <div className="relative mx-auto w-full">
          {/* keep a fixed height so layout doesn't jump; child animations are absolute/relative inside */}
          <div className="min-h-[400px] md:min-h-[520px] relative overflow-hidden">
            {renderActive()}
          </div>
        </div>
      </div>
    </section>
  )
}